export const landing = {
  heroTitle: 'Take control of your life in one app',
  heroSubtitle: 'The all-in-one platform for professionals seeking maximum productivity, financial control, and AI-powered personal growth',
  createFreeAccount: 'Create Free Account',
  seeDemo: 'See Demo',
  learnMore: 'Learn More',
  
  featuresTitle: 'Everything you need to succeed',
  
  productivityHub: 'Productivity Hub',
  productivityHubDesc: 'Your central command for achieving goals and optimizing your time',
  goalManagement: 'Goal and Objective Management',
  taskManagement: 'Task and Project Management',
  timeOrganization: 'Time Organization and Calendar',
  productivityAnalytics: 'AI-Powered Productivity Analytics',
  
  financeModule: 'Finance Module',
  financeModuleDesc: 'Complete control of your personal finances with artificial intelligence',
  smartBudgets: 'Smart Budgets',
  expenseTracking: 'Expense and Income Tracking',
  debtManagement: 'Debt and Investment Management',
  predictiveFinancial: 'AI-Powered Predictive Financial Analysis',
  
  complementaryFeatures: 'Complementary Features',
  complementaryFeaturesDesc: 'Additional tools for a more organized life',
  personalJournal: 'Personal Journal',
  habitTracking: 'Habit Tracking',
  listsOrganization: 'Lists and Organization',
  ideaGenerator: 'Idea Generator',
  documentsNotes: 'Documents and Notes',
  emailManagement: 'Email Management',
  financialEducation: 'Financial Education',
  productivityEducation: 'Productivity Education',
  
  howItWorksTitle: 'How it works',
  step1Title: 'Sign Up Free',
  step1Desc: 'Create your account in seconds without a credit card',
  step2Title: 'Organize Your Life',
  step2Desc: 'Set up your goals, tasks, budgets, and start working',
  step3Title: 'Grow with AI',
  step3Desc: 'Get intelligent insights and improve continuously',
  
  aiAnalyticsTitle: 'Powered by Artificial Intelligence',
  aiAnalyticsSubtitle: 'Discover the power of predictive analytics for your life',
  predictiveFinanceTitle: 'Predictive Financial Analysis',
  predictiveFinanceDesc: 'Intelligent projections of your future income and expenses based on historical patterns',
  productivityAnalysisTitle: 'Productivity Analysis',
  productivityAnalysisDesc: 'Identify patterns and trends in your time usage to maximize your efficiency',
  aiFinancialAssistantTitle: 'AI Financial Assistant',
  aiFinancialAssistantDesc: 'Receive personalized recommendations to optimize your finances and reach your goals',
  aiAccuracy: 'AI Accuracy',
  aiFaster: 'Faster',
  aiAvailable: 'Available',
  aiPossibilities: 'Possibilities',
  
  pricingTitle: 'Plans designed for you',
  monthlyPlan: 'Monthly',
  annualPlan: 'Annual',
  freePlanTitle: 'Free Plan',
  freePlanDesc: 'Perfect to get started',
  premiumPlanTitle: 'Premium Plan',
  premiumPlanDesc: 'For demanding professionals',
  perMonth: 'per month',
  perYear: 'per year',
  savePerYear: 'Save $21.88 per year',
  seeFullComparison: 'See full comparison',
  chooseFreePlan: 'Start Free',
  choosePremiumPlan: 'Get Premium',
  allFeatures: 'All features',
  basicFeatures: 'Basic features',
  advancedAnalytics: 'Advanced analytics',
  aiPowered: 'AI-powered predictive analysis',
  prioritySupport: 'Priority support',
  noAds: 'No ads',
  advancedExport: 'Advanced export',
  mainDashboard: 'Main dashboard',
  limitedFeatures: 'Limited features',
  emailSupport: 'Email support',
  mostPopular: 'Most Popular',
  
  testimonialsTitle: 'What our users say',
  testimonial1Text: 'PlanWiseNow completely transformed the way I work. Now I can manage multiple projects without losing control of my finances.',
  testimonial1Author: 'Carlos Mendoza',
  testimonial1Role: 'Digital Entrepreneur',
  testimonial2Text: 'The AI analytics helped me identify spending patterns I never noticed before. I\'ve saved over $500 in three months.',
  testimonial2Author: 'Maria González',
  testimonial2Role: 'Freelance Designer',
  testimonial3Text: 'As a team manager, I needed more than just a simple task app. PlanWiseNow gives me the complete view I need.',
  testimonial3Author: 'Roberto Silva',
  testimonial3Role: 'Project Manager',
  testimonial4Text: 'The integration of productivity and finances in one platform is amazing. I no longer need 5 different apps.',
  testimonial4Author: 'Ana Martinez',
  testimonial4Role: 'Independent Consultant',
  
  faqTitle: 'Frequently Asked Questions',
  faqQuestion1: 'What does the free plan include?',
  faqAnswer1: 'The free plan includes basic features of all modules: task management, goals, budgets, journal, habits, and more. It\'s perfect to start and explore the platform.',
  faqQuestion2: 'How do the AI analytics work?',
  faqAnswer2: 'Our AI system analyzes your historical productivity and financial data to identify patterns, make predictions, and offer personalized recommendations to help you improve.',
  faqQuestion3: 'Can I cancel anytime?',
  faqAnswer3: 'Yes, you can cancel your Premium subscription at any time from your account settings. There are no long-term commitments.',
  faqQuestion4: 'Is my data secure?',
  faqAnswer4: 'Absolutely. We use bank-level encryption and comply with all international security standards. Your data will never be shared with third parties.',
  faqQuestion5: 'Is it compatible with mobile devices?',
  faqAnswer5: 'Yes, PlanWiseNow is fully responsive and works perfectly on smartphones, tablets, and computers. Native apps coming soon.',
  faqQuestion6: 'Do you offer refunds?',
  faqAnswer6: 'Yes, we offer a 30-day money-back guarantee on the Premium plan. If you\'re not satisfied, we\'ll refund your money, no questions asked.',
  
  ctaTitle: 'Ready to transform your productivity?',
  ctaSubtitle: 'Join thousands of professionals who are already taking control of their lives',
  startFreeNow: 'Start Free Now',
  noCardRequired: 'No credit card required',
  noCommitments: 'No commitments',
  cancelAnytime: 'Cancel anytime',
  secureData: 'Secure data',
  
  footerDescription: 'Your personal productivity and finance assistant',
  footerQuickLinks: 'Quick Links',
  footerFeatures: 'Features',
  footerPricing: 'Pricing',
  footerBlog: 'Blog',
  footerContact: 'Contact',
  footerLegal: 'Legal',
  footerPrivacy: 'Privacy Policy',
  footerTerms: 'Terms of Service',
  footerRefund: 'Refund Policy',
  footerSocial: 'Follow Us',
  
  newsletter: {
    comingSoon: "🚀 Coming Soon!",
    subtitle: "Be the First to Know",
    description: "Join our exclusive pre-launch list and get early access to PlanWiseNow. Transform how you manage your time, goals, and finances.",
    emailPlaceholder: "your@email.com",
    namePlaceholder: "Your name (optional)",
    later: "Maybe Later",
    subscribe: "Count Me In!",
    subscribing: "Subscribing...",
    privacy: "We respect your privacy. No spam, ever.",
    success: "Welcome aboard! 🎉",
    successDesc: "Check your email for confirmation details.",
    error: "Oops!",
    errorDesc: "Something went wrong. Please try again.",
    emailRequired: "Please enter your email address.",
    alreadySubscribed: "Already subscribed!",
    alreadySubscribedDesc: "You're already on our list. Stay tuned!"
  }
};
